import { ApolloClient } from "@apollo/client";
import { ClientesDsCloudRepository } from "../../bussines/repository/ClienteDsCloud.repository";
import { ClientesDsCloudApolloProvider } from "../providers/apollo/ClienteDsCloud.provider";
import { ClienteDsCloud } from "../../bussines/entities/clienteDsCloud.enity";
import { paramsGetClientesDsCloud, paramsSetEstadoCuentaPorSuscrip } from "../../bussines/params/ClienteDsCloud.params";

export class ClienteDsCloudDataSource implements ClientesDsCloudRepository {
    private ClientesDsCloudProvider: ClientesDsCloudApolloProvider;

    constructor(ApolloClient: ApolloClient<object>) {
        this.ClientesDsCloudProvider = new ClientesDsCloudApolloProvider(ApolloClient);
    }
    getClientesDsCloud(variables: paramsGetClientesDsCloud): Promise<ClienteDsCloud[]> {
        return this.ClientesDsCloudProvider.getClientesDsCloud(variables);
    }
    setEstadoCuentaPorSuscrip(variables: paramsSetEstadoCuentaPorSuscrip): Promise<string> {
        return this.ClientesDsCloudProvider.setEstadoCuentaPorSuscrip(variables);
    }
}